<template>
	<v-chip small :color="ui.color">
		{{ text }}
	</v-chip>
</template>

<script>
import moment from "moment";

export default {
	props: {
		date: {
			type: String,
			required: true,
		},

		format: {
			type: String,
			required: true,
		}
	},

	data() {
		return {
			text: null,

			ui: {
				color: "default",
			},
		};
	},

	created() {
		this.start();
	},

	methods: {
		start() {
			let color = "default";
			var date = moment(this.date, [this.format]).format("YYYY-MM-DD h:mm a");
			if (
				moment(this.date, [this.format]).format("YYYY-MM-DD") ==
				moment().format("YYYY-MM-DD")
			) {
				date = `Hoy a la: ${moment(this.date, [this.format]).format("h:mm a")}`;
				color = "accent";
			}

			this.text = date;

			this.ui.color = color;
		},
	},
};
</script>

<style lang="css" scoped></style>
